import * as Sentry from '@sentry/vue'

const EXTENSION_SCHEMES = ['chrome-extension:', 'moz-extension:', 'safari-web-extension:']

export function isBrowserExtensionViolation(report) {
  return [report?.blockedURI, report?.sourceFile].some(value =>
    EXTENSION_SCHEMES.some(scheme => String(value || '').startsWith(scheme))
  )
}

export function reportCspViolation(report) {
  if (!report || isBrowserExtensionViolation(report)) return

  const disposition = report.disposition || 'report'
  const directive = report.effectiveDirective || 'unknown'
  const blockedURI = report.blockedURI || ''

  Sentry.withScope(scope => {
    scope.setLevel('warning')
    scope.setTag('csp.disposition', disposition)
    scope.setTag('csp.directive', directive)
    scope.setFingerprint(['csp', disposition, directive, blockedURI])
    scope.setContext('csp', {
      blockedURI,
      sourceFile: report.sourceFile || '',
      lineNumber: report.lineNumber ?? null,
      sample: report.sample || ''
    })
    Sentry.captureMessage(`CSP ${disposition}: ${directive} blocked ${blockedURI || 'inline'}`)
  })
}

export function startCspViolationReporting(enabled) {
  const queued = Array.isArray(window.__cspViolations) ? window.__cspViolations.splice(0) : []
  window.__reportCspViolation = enabled ? reportCspViolation : () => {}
  if (enabled) queued.forEach(reportCspViolation)
}
